import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';
import { LoginResponseModel } from 'src/app/models/loginresponse.model';

const PREFIXPROFILE = 'wt__t7._0';
const PREFIXTOKEN = 'tzZ_00122yYm_2';
const PREFIXRECOVERYTOKEN = 'jdJkw-_2129DDd2__';
const EXPIREDLANDING = 'pr0._3xp_.l4n';
const SITESEXPIRED = 'fr21._4xp_.l8n';

@Injectable({
  providedIn: 'root'
})
export class StoragePermissionService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
  site = environment.multisite.name;
  userToken: string;
  sitesExpired: string[] = [];

  setUsage() {
    this.setUsageWithType();
    return localStorage.setItem(`${EXPIREDLANDING}`, 'true');
  }

  private setUsageWithType() {
    this.sitesExpired = this.getTypesLandingsExpired() || [];
    this.sitesExpired.push(this.site);
    localStorage.setItem(`${SITESEXPIRED}`, JSON.stringify(this.sitesExpired));
  }

  getTypesLandingsExpired(): string[] {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem(`${SITESEXPIRED}`)) || [];
    }
  }

  isAlreadyUsed(): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(`${EXPIREDLANDING}`);
    }
  }

  setStorageProfile(data): any {
    return localStorage.setItem(`${PREFIXPROFILE}`, data);
  }

  setUserIP(user_ip: string): any {
    return localStorage.setItem(`user_ip`, user_ip);
  }

  setDomainToRedirect(domain: string): any {
    return localStorage.setItem(`domain_redirect`, domain);
  }

  setCountryCode(code: string): any {
    return localStorage.setItem(`country_code`, code);
  }

  setEnvironment(domain: string): any {
    return localStorage.setItem(`environment`, domain);
  }

  setToken(response: LoginResponseModel): any {
    let today = new Date();
    today.setSeconds(response.expires_in);
    localStorage.setItem('expires', today.getTime().toString());
    return localStorage.setItem(`${PREFIXTOKEN}`, response.access_token);
  }

  setRecoveryToken(response): any {
    return localStorage.setItem(`${PREFIXRECOVERYTOKEN}`, response);
  }

  getToken(): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(`${PREFIXTOKEN}`);
    }
  }

  getUserIP(): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(`user_ip`);
    }
  }

  getEnvironment(): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(`environment`);
    }
  }

  getDomainToRedirect(): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(`domain_redirect`);
    }
  }

  getCountryCode(): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(`country_code`);
    }
  }

  getExpireToken(): number {
    if (isPlatformBrowser(this.platformId)) {
      return Number(localStorage.getItem('expires'));
    }
  }

  getProfile(): any {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem(`${PREFIXPROFILE}`));
    }
  }

  setStorage(name, data): any {
    return localStorage.setItem(this.site + name, data);
  }

  getStorage(name): any {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(this.site + name);
    }
  }

  setUserHash(hash: string): any {
    return localStorage.setItem(`userHash`, hash);
  }

  getUserHash(): string {
    return localStorage.getItem(`userHash`);
  }

  setCasinoGame(data: any): any {
    return localStorage.setItem(`casino`, JSON.stringify(data));
  }

  getCasinoGame(): { game: number; promo: string } {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem('casino'));
    }
  }

  clearData(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }

  isAuthenticatedByToken(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const expire = Number(localStorage.getItem('expires'));
      const toExpired = new Date();
      toExpired.setTime(expire);
      if (toExpired > new Date() && this.getToken().length > 10) {
        return true;
      } else {
        return false;
      }
    }
  }
}
